import type { PropsWithChildren } from 'react';
import type React from 'react';
import styled from 'styled-components';

export interface SidebarProps {
  isOpen: boolean;
}

export const Sidebar: React.FC<PropsWithChildren<SidebarProps>> = ({ isOpen, children }) => {
  return (
    <Container data-test="sidebar" style={{ transform: isOpen ? 'unset' : 'translateX(100%)' }}>
      {children}
    </Container>
  );
};

const Container = styled.div`
  flex: 0 0 auto;
  width: 25rem;
  position: relative;
  transition: transform 0.3s ease;
  background-color: ${({ theme }): string => theme.customPalette.panels.side.background};
  overflow: auto;
  box-shadow: -2px 0 3px rgb(80 90 98 / 50%);
  padding: 0.8em 0;
  display: grid;
  grid-template-rows: 3em 1fr 5em;
  grid-template-areas:
    'sideheader'
    'sidecontent'
    'approve';

  @media (max-width: 100rem) {
    grid-template-rows: 2em 1fr 3.6em;
  }
`;
